module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-title big-title"
  }, [_vm._v("\n            Rapport de Dungeon Bowl\n        ")]), _vm._v(" "), _vm._l((_vm.teamReportList), function(tr) {
    return (_vm.current) ? [_c('hr'), _vm._v(" "), _c('div', {
      staticClass: "panel-content"
    }, [_c('div', {
      staticClass: "large-12 columns"
    }, [_c('DBTeamReportViewer', {
      attrs: {
        "tr": tr
      }
    })], 1)])] : _c('div', [_c('spinner')], 1)
  }), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('commentPanel', {
    attrs: {
      "entity_type": _vm.mrContentType.id,
      "entity_id": _vm.id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b78d738e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/match-reports/mr-db-detail.vue
// module id = 795
// module chunks = 0